<template>
	<div>
		<mt-field label="请选择城市" disabled v-model="MealCityDictVal" @click.native="selectCity">
			<svg class="icon" aria-hidden="true">
				<use xlink:href="#icon-arrow-right"></use>
			</svg>
		</mt-field>
		<div class="mettingType">
			<!--<mt-field label="会议类型" disabled v-model="mettingType.txt" @click.native="Handle('mettingType')" v-if="MealCityDictVal">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-arrow-right"></use>
                </svg>         
            </mt-field>-->
		</div>
		<div class="search">
			<mt-button type="default" size="large" @click="search">开始搜索</mt-button>
		</div>
	</div>
</template>
<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	// import PopupFullPicker from '@/components/popup-full-picker'
	import selectInfo from '@/components/selectInfo.js'
	import { mealQuery as mealQueryValidator } from '@/validatorConfig/mealQuery'
	export default {
		extends: selectInfo,
		data() {
			return {

			}
		},
		computed: {
			...mapGetters([
				'MealCityDictVal',
				'mettingType'
			])
		},
		methods: {
			...mapActions([
				'GetOpenMealUrlPromise'
			]),
			selectCity() {
				const currentRoute = this.$route.path
				this.$router.push({
					path: '/selectCity',
					query: {
						mealQueryType: 2,
						backRoute: currentRoute
					}
				})
			},
			query() {
				let params = {

				}
			},
			async search() {
				var params = {
					cityDictVal: this.MealCityDictVal,
					// typeMeetVal: this.mettingType.val
					tenantId: this.iStorage.get('tenantId')
				}
				const validateResult = this.validate(params, mealQueryValidator);
				if(!validateResult) return;
				const res = await this.GetOpenMealUrlPromise(params)
				if(res && res.success) {
					let mshopUrl = res.content;
					const rnd = new Date().getTime();
					mshopUrl += "&action=search&qshop=true&rejecttabs=0,2" + "&rnd=" + rnd + "&tenantcode=" + this.iStorage.get('tenant_code');
					let appType = this.iStorage.get('appType');
					if(appType == 'iEvent') {
						mshopUrl += "&appfrom=ievent";
						this.JSbridge.openWebapp({
							loadUrl: mshopUrl
						});
					}else{
						window.location.href = mshopUrl
					}
					this.iStorage.set('Selected', "2")
				}
			}
		},
		// components: {
		//     PopupFullPicker
		// }
	}
</script>
<style lang="scss">
	.mettingType {
		height: 48px;
	}
</style>


// WEBPACK FOOTER //
// src/components/mealQuery.vue